export const getRolNameById = (roles, rolId) =>
    roles.find((x) => x.id === Number(rolId))?.rol;

export const summarizeSelections = (roles, parts) => {
    const clientCounts = new Map();
    const workerRoleCounts = new Map();

    (parts || []).forEach((p) => {
        const personaId = Number(p.persona?.id ?? p.persona);
        const rolName = getRolNameById(roles, p.rol?.id ?? p.rol);
        if (!personaId || !rolName) return;

        if (rolName === "CAZADOR") {
            clientCounts.set(personaId, (clientCounts.get(personaId) || 0) + 1);
        } else if (rolName === "SECRETARIO" || rolName === "CARGADOR") {
            const map = workerRoleCounts.get(personaId) || new Map();
            map.set(rolName, (map.get(rolName) || 0) + 1);
            workerRoleCounts.set(personaId, map);
        }
    });

    return { clientCounts, workerRoleCounts };
};

export const personasFiltradasPara = ({ roles, personas, parts, index }) => {
    const current = parts[index] || {};
    const currentPersonaId = Number(current.persona?.id ?? current.persona);
    const currentRolName = getRolNameById(roles, current.rol?.id ?? current.rol);
    const { clientCounts, workerRoleCounts } = summarizeSelections(roles, parts);

    if (!currentRolName) return personas;

    if (currentRolName === "CAZADOR") {
        return personas.filter((per) => {
            if (per.tipoPersona !== "CLIENTE") return false;
            if (per.id === currentPersonaId) return true;
            return !clientCounts.has(per.id);
        });
    }

    if (currentRolName === "SECRETARIO" || currentRolName === "CARGADOR") {
        return personas.filter((per) => {
            if (per.tipoPersona !== "STAFF") return false;
            if (per.id === currentPersonaId) return true;

            const roleMap = workerRoleCounts.get(per.id) || new Map();
            const alreadyHasThisRole = (roleMap.get(currentRolName) || 0) >= 1;
            const distinctRoles = Array.from(roleMap.keys()).length;

            if (alreadyHasThisRole) return false;
            if (distinctRoles >= 2) return false;
            return true;
        });
    }

    return personas;
};

export const validateParticipationRules = (roles, parts) => {
    const { clientCounts, workerRoleCounts } = summarizeSelections(roles, parts);

    for (const [, count] of clientCounts.entries()) {
        if (count > 1) {
            alert("Un mismo CLIENTE no puede ser CAZADOR más de una vez en la cacería.");
            return false;
        }
    }

    for (const [, roleMap] of workerRoleCounts.entries()) {
        const distinctRoles = Array.from(roleMap.keys()).length;

        for (const [, cnt] of roleMap.entries()) {
            if (cnt > 1) {
                alert("Un STAFF no puede repetirse en el mismo rol más de una vez.");
                return false;
            }
        }

        if (distinctRoles > 2) {
            alert("Un STAFF no puede participar en más de dos roles (SECRETARIO/CARGADOR).");
            return false;
        }
    }

    return true;
};
